<template>
  <div v-if="discountCode">
    <BaseAlert
      icon="percentage"
      :text="text"
      :size="size"
    />
  </div>
</template>

<script
  lang="ts"
  setup
>
import { useI18n } from 'vue-i18n';
import filters from '@/filters';
import { DiscountCodeDiscountTypeEnum } from '@/types';

const props = withDefaults(
  defineProps<{
    discountCode: {
      code: string;
      discountAmount: number;
      discountPercentage: number;
      discountType: DiscountCodeDiscountTypeEnum;
      serviceIds: number[];
    };
    size: 's' | 'm';
  }>(),
  {
    size: 'm',
  },
);

const { t } = useI18n();

const text = computed(() => {
  const code = props.discountCode?.code;
  const percentage = props.discountCode?.discountPercentage;
  const amount = filters.currency(props.discountCode.discountAmount);

  if (props.discountCode.serviceIds?.length) {
    return t('appointment.discount_code_used_services', {
      code,
      amount: props.discountCode.discountAmount ? amount : `${percentage}%`,
    });
  } else if (
    props.discountCode?.discountType ===
    DiscountCodeDiscountTypeEnum.FixedAmount
  ) {
    return t('appointment.discount_code_used_fixed', {
      code,
      amount,
    });
  } else {
    return t('appointment.discount_code_used', {
      code,
      percentage,
    });
  }
});
</script>
